import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import Filter from 'views/accounting/employees/filter'; // Importing Filter component
import Table from 'views/accounting/employees/table'; // Importing Table component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the workers view.
 * @extends JetView
 */
export default class workersView extends JetView {
    /**
     * Configures the layout of the workers view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const screen = this.app.config.size; // Current screen size

        const right = {
            type: 'wide',
            rows: [],
        };

        /**
         * Toolbar configuration with pagination and export options.
         * @type {Object}
         */
        const toolbar = {
            view: 'toolbar',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'select', // Dropdown for selecting number of items per page
                    options: ['10', '20', '50', '100'],
                    width: 70,
                    on: {
                        onChange: function () {
                            // Event handler for changing page size
                            $$('datatable').getPager().config.size = this.getValue() * 1; // Update pager size
                            $$('datatable').refresh(); // Refresh the datatable
                        },
                    },
                },
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default fetch size from config
                },
                {
                    view: 'richselect', // Dropdown for export options
                    name: 'Export',
                    id: 'ExportEmployees',
                    width: 120,
                    placeholder: _('Exportar'), // Placeholder text
                    options: [
                        { id: '1', value: 'Excel' }, // Excel export option
                        { id: '2', value: 'PDF' }, // PDF export option
                    ],
                    on: {
                        onChange: function (value) {
                            // Event handler for export selection
                            if (value == 1) {
                                // Excel export
                                var table = $$('datatable'); // Reference to the datatable
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    if (table.config.columns[j].exportType) {
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                webix.toExcel(table, {
                                    // Export to Excel
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                        'Empleados',
                                    ignore: { rating: true }, // Ignore rating column in export
                                });
                            } else {
                                if (value == 2) {
                                    // PDF export
                                    webix.toPDF($$('datatable'), {
                                        // Export to PDF
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                })
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                .replace(/[\/:]/g, '_')
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                            'Empleados',
                                        autowidth: true, // Auto width for PDF
                                        ignore: { rating: true }, // Ignore rating column in export
                                    });
                                }
                            }
                            $$('ExportEmployees').setValue(''); // Reset export selection
                        },
                    },
                },
            ],
        };

        const left = {
            Width: 250,
            responsiveCell: false,
            rows: [
                {
                    view: 'toolbar', // Toolbar for the left section
                    css: theme,
                    elements: [
                        { id: 'grav' }, // Placeholder element
                        {
                            cols: [
                                {
                                    view: 'button', // Button to add area
                                    value: _('Añadir Área'),
                                    type: 'form',
                                    width: screen == 'small' ? 0 : 200,
                                    minWidth: 250,
                                    hidden: !devConfig.getPermAction(
                                        'accountingEmployeesAdd',
                                        'Add', // Check permission for adding employees
                                    ),
                                    css: 'prm-accountingEmployeesAdd',
                                    click: () => {
                                        // Click event for button
                                        this.app.callEvent(
                                            'addEmployees:button',
                                            [{}], // Trigger add employees event
                                        );
                                    },
                                },
                            ],
                        },
                    ],
                },
                Table, // Reference to the Table component
                toolbar, // Reference to the toolbar
            ],
        };

        webix.ui.fullScreen(); // Set the UI to full screen mode
        return {
            id: 'a5',
            type: 'clean',
            view: 'form',
            scroll: 'y',
            rows: [
                {
                    responsive: 'a5',
                    type: 'wide',
                    cols: [left], // Left section with toolbar and table
                },
            ],
        };
    }

    /**
     * Initializes the workers view.
     */
    init() {
        if (screen.width < 500) {
            // Check screen width for responsive design
            $$('grav').hide(); // Hide element if screen is small
        }
    }
}

// FILE DOCUMENTED
